/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Help': {
    width: 28,
    height: 28,
    viewBox: '0 0 28 28',
    data: '<defs><path pid="0" id="svgicon_Help_a" d="M10.011 20A10 10 0 1120 10.011c-.006 5.514-4.475 9.983-9.989 9.989zm0-18.896a8.907 8.907 0 10-.022 17.814 8.907 8.907 0 00.022-17.814zm1.235 6.262A1.202 1.202 0 009.956 6.1a2.12 2.12 0 00-1.584.797l-.853-.776a3.443 3.443 0 012.612-1.256 2.317 2.317 0 012.58 2.393c0 1.913-2.328 2.623-2.11 4.58H9.28c-.317-2.208 1.967-3.083 1.967-4.47zm-2.295 6.667a1.016 1.016 0 011.005-1.093 1.027 1.027 0 011.017 1.093 1.005 1.005 0 01-1.017 1.093.984.984 0 01-1.005-1.093z"/></defs><g transform="translate(4.077 4.077)"><mask id="svgicon_Help_b"><use xlink:href="#svgicon_Help_a"/></mask><use xlink:href="#svgicon_Help_a"/><g mask="url(#svgicon_Help_b)"><path pid="1" d="M-4-4h28v28H-4z"/></g></g>'
  }
})
